import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  tipo?: number | null,
  prancha?: string | null,
  revisao?: string | null,
  descricao?: string | null,


};

type Actions = {
  setTipo: (value: number | null) => void;
  setPrancha: (value: string | null) => void;
  setRevisao: (value: string | null) => void;
  setDescricao: (value: string | null) => void;
  clear: () => void;

};

export const useProjetoImpressaoDisciplinaFilters = create<State & Actions>((set) => ({
  tipo: 2,
  prancha: null,
  revisao: null,
  descricao: null,
  setTipo: (value) => set({ tipo: value }),
  setPrancha: (value) => set({ prancha: value }),
  setRevisao: (value) => set({ revisao: value }),
  setDescricao: (value) => set({ descricao: value }),

  clear: () =>
    set({
      tipo: 2,
      prancha: null,
      revisao: null,
      descricao: null,
    }),
}));
